// extracted by mini-css-extract-plugin
export default {"container":"NavBar_container__vMDea","title":"NavBar_title__Csg23"};